import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';

// Utils
import { useTranslation } from 'next-i18next';
import useImage from '../../../src/hooks/useImage';
import cn from '../../../src/utils/cn';

import styles from './SlidesBanner.module.scss';

function SlidesBanner({ slides, lightboxRef, slidesImages }) {
  const { t } = useTranslation();
  const { getImageSrc } = useImage();

  const handleImageClick = () => {
    if (lightboxRef?.current && slidesImages?.length) {
      lightboxRef.current.open();
    }
  };

  return (
    <section className={`${styles.wrapper} flex`}>
      <div
        role="presentation"
        onClick={handleImageClick}
        className={cn([styles.image_wrapper, slidesImages?.length ? 'c-pointer' : ''])}
      >
        <div className={`${styles.image_holder} ${styles.high}`}>
          {slides[0]?.path ? (
            <Image
              loader={(img) => img?.src}
              unoptimized
              src={getImageSrc({
                fileId: slides[0]?.path,
                widths: {
                  default: 391,
                },
              })}
              alt={slides[0]?.path.split('/').pop()}
              layout="fill"
              objectFit="cover"
              priority
            />
          ) : null}
        </div>
      </div>
      <div
        role="presentation"
        onClick={handleImageClick}
        className={cn([styles.image_wrapper, slidesImages?.length ? 'c-pointer' : ''])}
      >
        <div className={styles.image_holder}>
          {slides[1]?.path ? (
            <Image
              loader={(img) => img?.src}
              unoptimized
              src={getImageSrc({
                fileId: slides[1]?.path,
                widths: {
                  default: 391,
                },
              })}
              alt={slides[1]?.path.split('/').pop()}
              layout="fill"
              objectFit="cover"
              priority
            />
          ) : null}
        </div>
        <div className={styles.image_holder}>
          {slides[2]?.path ? (
            <Image
              loader={(img) => img?.src}
              unoptimized
              src={getImageSrc({
                fileId: slides[2]?.path,
                widths: {
                  default: 391,
                },
              })}
              alt={slides[2]?.path.split('/').pop()}
              layout="fill"
              objectFit="cover"
              priority
            />
          ) : null}
        </div>
      </div>

      {slidesImages?.length ? (
        <button
          type="button"
          className={`${styles.open_lightbox} fs-16 fw-500 text-uppercase c-pointer`}
          onClick={() => lightboxRef.current.open()}
        >
          {t('camp.details.lightbox.show')}
        </button>
      ) : null}
    </section>
  );
}

SlidesBanner.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.shape({})),
};

SlidesBanner.defaultProps = {
  slides: [],
};

export default SlidesBanner;
